import React, {useEffect, useMemo, useState} from 'react';
import {FilterModalOption, useFilterModal} from '@basicComponents/filter-modal';
import {getGameProvider} from './casino.service';
import {sortBy} from '@/common-pages/live-casino/live-casino-service';

const SelectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      className="w-3 h-3"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <path
        d="M2.77778 5L5.88889 8.11111L9 5"
        stroke="#9FA5AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function CasinoSelectItem({
  optionsList,
  name,
  modalTitle = 'Please Choose',
  onChange,
  initialValue,
}: {
  optionsList: FilterModalOption[];
  name: string;
  modalTitle?: string;
  onChange: (value: any) => void;
  initialValue?: string;
}) {
  const {show, renderModal, currentValue, currentTitle} = useFilterModal(
    name,
    optionsList,
    true,
    initialValue,
    modalTitle,
  );
  const handleClick = () => {
    show();
  };
  useEffect(() => {
    onChange?.(currentValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);
  return (
    <>
      <div
        onClick={handleClick}
        className="py-1 text-black px-2 h-8 flex items-center w-[10.625rem] rounded border border-[#d8e0ea]">
        <span className="overflow-ellipsis text-nowrap flex-1 overflow-hidden">
          {name}: {currentTitle}
        </span>
        <SelectIcon />
      </div>
      {renderModal}
    </>
  );
}

export default function CasinoSelect({
  handleChangeProvider,
  handleChangeSort,
  type,
  initialProvider,
  initialSort,
}: {
  handleChangeProvider: (value: string) => void;
  handleChangeSort: (value: string) => void;
  type: 'casino' | 'liveCasino';
  initialProvider?: string;
  initialSort?: string;
}) {
  const [providerList, setProviderList] = useState<FilterModalOption[]>([]);
  const sortByList = useMemo(() => {
    return sortBy.map(item => {
      return {
        title: item.label,
        value: item.value,
      };
    });
  }, []);
  useEffect(() => {
    // 获取筛选
    // 获取二级
    getGameProvider(type).then(res => {
      const newList = res.map(item => {
        return {
          title: item.name,
          value: item.id,
        };
      });
      setProviderList([{title: 'All', value: ''}, ...newList]);
    });
  }, [type]);
  return (
    <div className="flex justify-between items-center bg-white p-3">
      <CasinoSelectItem
        optionsList={providerList}
        name="Categories"
        onChange={handleChangeProvider}
        initialValue={initialProvider}
      />
      <CasinoSelectItem
        optionsList={sortByList}
        name="SortBy"
        onChange={handleChangeSort}
        initialValue={initialSort}
      />
    </div>
  );
}
